import { colorsPalettes } from "@similarweb/styles";
import { Text } from "@similarweb/ui-components/foundations";

import { StylesPageTitleWrapper } from "./styles";

type PageTitleProps = {
    text: string;
};

const PageTitle = (props: PageTitleProps) => {
    const { text } = props;

    return (
        <StylesPageTitleWrapper className="hidden-print">
            <Text
                data-automation="page-title"
                fontVariant="h2"
                color={colorsPalettes.carbon["500"]}
            >
                {text}
            </Text>
        </StylesPageTitleWrapper>
    );
};

export default PageTitle;
